import { render, staticRenderFns } from "./CheckYourEmail.vue?vue&type=template&id=df28f64c&scoped=true"
import script from "./CheckYourEmail.vue?vue&type=script&lang=js"
export * from "./CheckYourEmail.vue?vue&type=script&lang=js"
import style0 from "./CheckYourEmail.vue?vue&type=style&index=0&id=df28f64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df28f64c",
  null
  
)

export default component.exports